<template>
    <span v-if="mostrarBtnAprovar || mostrarBtnReprovar">
        <b-button
            variant="primary"
            @click.stop="confirmarAprovarReprovarEntrega('A')"
            v-if="mostrarBtnAprovar"
        >
            <span> <i class="fa fa-check-circle"></i> Aprovar </span>
        </b-button>
        <b-button
            variant="danger"
            @click.stop="abrirEntregaDetalheReprovacao()"
            v-if="mostrarBtnReprovar"
            class="ml-2"
        >
            <span> <i class="fa fa-times-circle"></i> Reprovar </span>
        </b-button>
        <b-modal
            id="modalEntregaDetalheReprovacao"
            v-model="mostrarModalEntregaDetalheReprovacao"
        >
            <div slot="modal-title">Entrega - Detalhe da Reprovação</div>
            <app-erros-box
                :erros="erros"
                v-if="erros.length > 0"
            ></app-erros-box>
            <b-row>
                <b-col sm="12">
                    <b-form-group>
                        <label for="contato">Detalhe da Reprovação</label>
                        <b-form-textarea
                            v-model="detalheReprovacao"
                            :rows="4"
                            @input="$v.detalheReprovacao.$touch()"
                            :state="$v.detalheReprovacao.$error ? false : null"
                        ></b-form-textarea>
                        <b-form-invalid-feedback
                            >O detalhe da reprovação é
                            obrigatório</b-form-invalid-feedback
                        >
                    </b-form-group>
                </b-col>
            </b-row>
            <div slot="modal-footer">
                <b-button
                    variant="secondary"
                    @click.stop="fecharEntregaDetalheReprovacao()"
                    >Cancelar</b-button
                >
                <b-button
                    variant="danger"
                    :disabled="$v.$invalid"
                    @click.stop="confirmarAprovarReprovarEntrega('R')"
                    class="ml-2"
                >
                    <span> <i class="fa fa-times-circle"></i> Reprovar </span>
                </b-button>
            </div>
        </b-modal>
    </span>
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { entregaStatus } from './EntregaStatus'

export default {
    props: {
        entrega: {
            type: Object,
            default: () => ({})
        },

        entregasServicos: {
            type: Object,
            required: true,
            default: () => ({})
        }
    },

    data() {
        return {
            erros: [],
            mostrarModalEntregaDetalheReprovacao: false,
            detalheReprovacao: ''
        }
    },

    methods: {
        abrirEntregaDetalheReprovacao() {
            this.mostrarModalEntregaDetalheReprovacao = true
        },

        fecharEntregaDetalheReprovacao() {
            this.mostrarModalEntregaDetalheReprovacao = false
            this.detalheReprovacao = ''
        },

        confirmarAprovarReprovarEntrega(acao) {
            let acaoTitulo
            let acaoMensagem
            let html

            if (acao === 'A') {
                acaoTitulo = 'Aprovar'
                acaoMensagem = 'aprovação'
                html = `Confirma a ${acaoMensagem} da entrega?
                <br/><br/><div class="alert alert-danger" role="alert">
                <div class="row">
                            <div class="col-3">
                                <i class="fa fa-exclamation-circle fa-5x"></i>
                            </div>
                            <div class="col-9">
                                <h4>A aprovação desta entrega valida a execução dos serviços prestados de acordo
                                com os documentos comprobatórios inseridos na mesma.</h4>
                            </div>
                        </div>
		             </div>`
            } else {
                acaoTitulo = 'Reprovar'
                acaoMensagem = 'reprovação'
                html = `Confirma a ${acaoMensagem} da entrega?`
            }

            this.$swal({
                title: `${acaoTitulo} Entrega`,
                html: html,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.aprovarReprovarEntrega(acao)
                }
            })
        },

        aprovarReprovarEntrega(acao) {
            this.$store.dispatch('addRequest')
            let aprovaReprovaEntregaDto = {
                entregaId: this.$route.params.entregaId,
                acao: acao,
                detalheReprovacao: this.detalheReprovacao
            }
            this.entregasServicos
                .aprovarReprovarEntrega(aprovaReprovaEntregaDto)
                .then((response) => {
                    if (response) {
                        if (response.success) {
                            this.$toast.success(
                                'Registro atualizado com sucesso!',
                                'OK',
                                this.$toastConfig.success
                            )
                            this.$emit('obterEntregaAtualizada')
                        } else {
                            this.$toast.error(
                                'Erro ao atualizar entrega!!!',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                })
        }
    },

    computed: {
        mostrarBtnReprovar() {
            let retorno =
                (this.$temAcesso('CRED-GEST-ENTR-01') &&
                    this.entrega.status === entregaStatus.EM_APROVACAO) ||
                (this.$temAcesso('CRED-GER-ENTR-01') &&
                    this.entrega.status === entregaStatus.EM_APROVACAO_GERENTE)
            return retorno
        },

        mostrarBtnAprovar() {
            let retorno =
                (this.$temAcesso('CRED-GEST-ENTR-01') &&
                    this.entrega.status === entregaStatus.EM_APROVACAO &&
                    this.entrega.natureza === 'CONSULTORIA' &&
                    this.entrega.statusIdRm === 1) ||
                (this.$temAcesso('CRED-GER-ENTR-01') &&
                    this.entrega.status ===
                        entregaStatus.EM_APROVACAO_GERENTE &&
                    this.entrega.statusIdRm === 1)
            return retorno
        },

        mostrarMsgErroComprometimento() {
            let retorno =
                (this.$temAcesso('CRED-GEST-ENTR-01') &&
                    this.entrega.status === entregaStatus.EM_APROVACAO &&
                    this.entrega.statusIdRm !== 1) ||
                (this.$temAcesso('CRED-GER-ENTR-01') &&
                    this.entrega.status ===
                        entregaStatus.EM_APROVACAO_GERENTE &&
                    this.entrega.statusIdRm !== 1)
            return retorno
        }
    },

    validations: {
        detalheReprovacao: {
            required
        }
    }
}
</script>
